import React from 'react';
import logoIcon from '../../Assets/logo.png';

const Illustrations = ({
    children,
    imgIcon,
    mainHeading,
    bottomText,
    subHeading,
}) => {
    return (
        <div className=" w-full flex justify-center flex-1 bg-pills-bg-color-900 p-4"
        >
            {/* {bg-gradient-to-b from-[#FF5D1040] via-white to-[#FFFFFF]} */}

            <div className=" w-full flex flex-col gap-8">
                <img
                    className=' mt-8 w-44 lg:hidden mx-auto'
                    src={logoIcon}
                    alt={"logo-Icon"}
                />
                <div className="max-w-4xl mx-auto">
                    {children}
                    {/* <hr className=' h-[0.16rem] bg-black mb-6' /> */}

                    {/* Main content section */}
                    <div className="">
                        <div className=" w-full max-w-lg mx-auto flex flex-col justify-center">
                            <div className=" w-3/5 lg:w-4/5 aspect-square mb-7 mx-auto ">
                                <img
                                    src={imgIcon}
                                    alt="Main character illustration"
                                    className="w-full h-full object-contain mx-auto"
                                />
                            </div>

                            <h2 className="text-black text-xl md:text-2xl font-bold mb-2 text-center">{mainHeading}</h2>
                            <h3 className="text-text-color text-md md:text-sm mb-2 text-center">{subHeading}</h3>


                            {
                                bottomText && (
                                    <div className="text-center max-w-2xl mx-auto -mt-8">
                                        <p className="text-gray-800 text-base md:text-lg">
                                            {bottomText}
                                        </p>
                                    </div>
                                )
                            }

                            <div className='mx-auto mt-10'>
                                <svg width="52" height="6" viewBox="0 0 52 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="6" rx="3" fill="#FF5D0E" />
                                    <circle opacity="0.5" cx="35" cy="3" r="3" fill="#FF5D0E" />
                                    <circle opacity="0.5" cx="49" cy="3" r="3" fill="#FF5D0E" />
                                </svg>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Illustrations;